import store from 'index.js'
import {
  startGame,
  stopGame,
  setValuesToInitial,
  setAnimation,
  setInstantBet
} from './gameLogic.js'
import {
  createUI
} from './gameUI.js'
import { appendMyBetsRoulette, setRouletteRoundEnd } from '../rouletteGame.slice.js'

export function gameManager () {
  createUI()
}

export function resetGame () {
  setValuesToInitial()
}

export function start () {
  resetGame()
  startGame()
}

export function stop (stopNumber = 5) {
  stopGame(stopNumber)
}

export function toggleInstantBet (bool) {
  setInstantBet(bool)
}

export function toggleAnimation (bool) {
  setAnimation(bool)
}

export function ballStoppedAtTarget () {
  setTimeout(() => store.dispatch(setRouletteRoundEnd()), 200)
  setTimeout(() => store.dispatch(appendMyBetsRoulette(), 200))
}
